package com.trevorwiebe.timesheet.admin.rate.presentation

import com.trevorwiebe.timesheet.core.domain.model.Rate

sealed class RateEvent {
    data object OnAddRateClick : RateEvent()
    data class OnEditRateClick(val rate: Rate) : RateEvent()
    data object OnDismissDialog : RateEvent()
    data class OnSaveRate(
        val description: String,
        val rateCode: String,
        val overtimeRateCode: String,
        val defaultRate: Boolean
    ) : RateEvent()
    data object OnErrorShown : RateEvent()
}
